import { FacilityLocation, ProviderLocationIdentifier } from "@harlowe/core";
import { Procedure } from "@harlowe/core";
import { TealCompClaim } from "./teal-comp-claim";
import { Type } from "class-transformer";
import { HarloweSupport } from "@harlowe/core";
import { Adjuster, AdjusterRole } from "./adjuster";
import { Contract } from "./contract";

export interface TealCompReferralHeader
{
    id: number;
    adjusterName: string;
    carrierName: string;
    referringProviderName: string;
    servicingProviderName: string;
    procedureCategory: string;
    claimNumber: string;
    status: string;
    closureReason: number;
    submissionDate: Date;
    approvedDate: Date;
    submitterJobFunction: string;
    submitterName: string;
    submitterPhone: string;
    submitterEmail:string;
    approvalRequestDate?:Date;
    claimId: number;
    encounterId: number;
    referringProviderId: ProviderLocationIdentifier;
    servicingProviderId: ProviderLocationIdentifier;
    procedureIds: number[];
    submissionI: number;
    specialInstructions: string;
    patientName: string;
    adjusterApprovalLink?: string;
}


export interface TealCompReferralSubmission
{
    id:number;
    externalId: string;
    patientFirstName: string;
    patientLastName: string;
    patientDateOfBirth: Date;
    adjusterFirstName: string;
    adjusterLastName: string;
    adjusterPhone: string;
    adjusterEmail:string;
    addressLine1: string;
    addressLine2: string;
    addressCity: string;
    addressState: string;
    addressZip:string;
    patientPhone: string;
    patientEmail: string;
    claimNumber: string;
    dateOfInjury: Date;
    jurisdiction: string;
    accidentDescription: string;
    injuryDescription: string;
    procedureType: string;
    procedures: SubmissionProcedure[];
    submittedByFirstName: string;
    submittedByLastName: string;
    submitterJobFunction: string;
    submitterPhone: string;
    submitterEmail: string;
    specialInstructions: string;
    servicingProvider: string;
    referringProvider: string;
    referringProviderLocation: string;
    payerName: string;
    bodyPart: string;
    bodySide: string;
}

export interface SubmissionProcedure
{
    procedureCode: string;
    bodyPart: string;
    side: string;
}


export interface ITealCompReferral
{
    referringProvider?: FacilityLocation;
    servicingProvider?: FacilityLocation;
    procedures: Procedure[];
    claim?: TealCompClaim;
    status: string;
    closureReason:number;
    submissionDate: Date;
    approvedDate?: Date;
    submitterJobFunction?:string;
    submitterName?: string;
    submitterPhone?: string;
    submitterEmail?: string;
    submission: TealCompReferralSubmission;
    referralComplete: boolean;
    missingProperties: string[];
    authorized: boolean;
    specialInstructions?: string;
    attachments: HarloweSupport.File[];
    adjusterApprovalLink?: string;
    authorization? : Contract;

}



export class TealCompReferral implements ITealCompReferral
{
    constructor
    (
        public id: number,
        public encounterId: number,
        public status: string,
        public closureReason: number,
        public submissionDate: Date,
        public submission: TealCompReferralSubmission

    )
    {

    }
    servicingProvider?: FacilityLocation;
    referralComplete: boolean = false;
    missingProperties: string[] = [];
    authorized: boolean = false;
    referringProvider?: FacilityLocation;
    
    submitterJobFunction?: string;


    @Type(() => Procedure)
    procedures: Procedure[] = [];

    @Type(() => TealCompClaim)
    claim?: TealCompClaim;
    
    approvedDate? : Date;
    submitterName?: string;
    submitterPhone?: string;
    submitterEmail?: string;
    specialInstructions?: string;
    adjusterApprovalLink?: string;
    attachments: HarloweSupport.File[]= [];
    selectedContractApprover?: Adjuster;

    authorization? : Contract;

    get patientName (): string | undefined
    {
        return this.claim?.party.firstName + " " + this.claim?.party.lastName;
    } 
    get procedureCategory(): string | undefined
    {
        return this.procedures[0]?.category.categoryName ?? this.submission.procedureType;
    }
    get carrierName () : string | undefined
    {
        return this.claim?.carrier?.name;
    }
    get selectedAdjusterName () : string | undefined
    {
        return this.selectedContractApprover?.fullName
    }
    get availableContractRecipients(): AdjusterRole[]
    {
        var adjusters : AdjusterRole[] = [];
        if(this.claim?.adjuster)
            adjusters = [... adjusters, new AdjusterRole(this.claim.adjuster,"Adjuster")];

        if(this.claim?.adjuster2)
            adjusters = [... adjusters, new AdjusterRole(this.claim.adjuster2,"Second Adjuster")];

        if(this.claim?.adjusterSupervisor)
            adjusters = [... adjusters, new AdjusterRole(this.claim.adjusterSupervisor,"Superviser")];
        return adjusters;
    }
}


export class ReferralClosureReason
{
    constructor
    ( 
        public description: string,
        public closureReason: number,
        public id: number
    )
    {}

}

export class TealCompReferralUpdate
{
    constructor
    (
        public referralId: number
    )
    {

    }

    status?: string;
    approvedDate?: Date;
    submitterJobFunction?:string;
    submitterName?: string;
    submitterPhone?: string;
    submitterEmail?: string;
    claimId?: number;
    referringProviderId?: ProviderLocationIdentifier;
    servicingProviderId?: ProviderLocationIdentifier;
    procedures?: number[];
    specialInstructions?: string;
    selectedAdjusterId?: number;

}

